/* import __COLOCATED_TEMPLATE__ from './push-notification-toggle.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();